/**
 * @module SalesFlow/evolved/view
 */

import {FlowCta} from 'view/ctas/shared/flow-cta';
import {FlowCtas} from 'view/ctas/shared/flow-ctas';

export class ViewEvolvedCtasRedPlusBase extends FlowCtas {

    /**
     * In Bnt the left button is always cross link into prolongation
     */
    protected getLeftButton (): FlowCta {

        return undefined;

    }

    /**
     * On device overview this is the right button. Overwrite when diff
     */
    protected getRightButton (): FlowCta {

        return undefined;

    }

}
